module.exports = __webpack_public_path__ + "img/b19e62e.png";